import { createFileRoute, redirect } from '@tanstack/react-router';
import { MewsTeam, RouteType } from '@mews/enums';

export const Route = createFileRoute('/_authenticated/$currentEnterpriseId/Admin/Settings/$ownerId/')({
    beforeLoad: ({ context: { checkPlatformPrivilege } }) => {
        checkPlatformPrivilege('accessAllEnterprises');
    },
    loader: ({ params: { currentEnterpriseId, ownerId } }) => {
        throw redirect({
            to: '/$currentEnterpriseId/Enterprise/Detail/$enterpriseId',
            params: { currentEnterpriseId, enterpriseId: ownerId },
        });
    },
    staticData: {
        owner: MewsTeam.Pricing,
        type: RouteType.Redirect,
    },
});
